<!-- 
  @desc 标题栏组件
  @version version=1.0.0 2019-11-07
  @author yd_zhegnshaobin
-->
<template>
  <div class="titleBar">{{ titleBar }}</div>
</template>

<script>
export default {
  props: {
    titleBar: String
  }
};
</script>

<style scoped lang="scss">
.titleBar {
  padding: 1rem;
  border-bottom: 1px solid #ebebeb;
  font-weight: bold;
  font-size: 0.875rem;
  -webkit-transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #303133;
}
.titleBar:hover {
  color: #6777ef;
  cursor: pointer;
}
</style>
